module.exports = __webpack_public_path__ + "static/media/externalSource.6d53dd09.svg";